var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 22,
    viewBox: "0 0 240 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4551_10176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29479 6.81379V19.0192H0.195312V2.98047H3.95543L15.9617 15.2033V2.98047H19.0612V19.0192H15.3011L3.29479 6.81379Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8191 19.0182H22.7207V2.97949H39.7769V6.18538H25.8213V9.40174H36.6796V12.6076H25.8191V15.8135H39.7746V19.0182H25.8191Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.105 2.98047L62.377 6.17238V6.18635H69.3547V19.0192H72.4542V6.18635H79.6931V2.98047",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3214 2.97949H43.209L50.0393 10.9826L43.209 18.9752H47.3214L54.1517 10.9826L47.3214 2.97949Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2149 8.56923L60.9924 2.98047H56.8801L54.1621 6.16074L56.2149 8.56923Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1621 15.8013L56.8801 18.9757H60.9924L56.2149 13.3975L54.1621 15.8013Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.545 11.941V10.0645C108.543 9.57066 108.636 9.0814 108.819 8.62528C109.002 8.16917 109.271 7.75537 109.611 7.40805C110.351 6.67313 111.204 6.30566 112.172 6.30566H115.502C116.47 6.30566 117.327 6.67313 118.072 7.40805C118.718 8.0726 119.096 8.96568 119.131 9.90734H117.31C117.27 9.43517 117.061 8.99551 116.724 8.67457C116.395 8.35091 115.956 8.17403 115.502 8.18217H112.172C111.691 8.1834 111.229 8.38233 110.889 8.73527C110.549 9.08821 110.359 9.56628 110.359 10.0645V11.941C110.361 12.438 110.552 12.9142 110.892 13.2658C111.231 13.6173 111.692 13.8156 112.172 13.8175H115.502C115.956 13.8256 116.395 13.6487 116.724 13.3251C117.06 13.0056 117.269 12.5682 117.31 12.0981H119.131C119.096 13.038 118.717 13.929 118.072 14.5916C117.327 15.3265 116.47 15.694 115.502 15.694H112.172C111.204 15.694 110.351 15.3265 109.611 14.5916C108.899 13.8256 108.544 12.9421 108.545 11.941Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52 14.1318L131.707 15.694H129.646L134.53 6.30566H136.433L141.316 15.694H139.256L138.443 14.1318H132.52ZM135.482 8.44408L133.497 12.2495H137.466L135.482 8.44408Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.427 9.43493C162.434 9.98893 162.292 10.534 162.018 11.0099C161.751 11.4765 161.375 11.8658 160.924 12.1414C160.464 12.4241 159.937 12.5703 159.402 12.564H154.788V15.6942H152.975V6.30587H159.4C159.935 6.29934 160.462 6.44598 160.921 6.7296C161.373 7.00591 161.75 7.39647 162.015 7.86458C162.29 8.3389 162.432 8.88226 162.427 9.43493ZM154.79 8.18237V10.6886H159.404C159.644 10.6885 159.878 10.6149 160.077 10.4772C160.276 10.3395 160.431 10.1438 160.523 9.91493C160.614 9.68606 160.638 9.43426 160.591 9.19135C160.544 8.94844 160.429 8.72533 160.26 8.55022C160.149 8.4315 160.016 8.33757 159.869 8.27428C159.722 8.211 159.564 8.17971 159.404 8.18237H154.79Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.088 6.30566H175.902V15.694H174.088V6.30566Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 6.30566V8.18217H193.462V15.694H191.648V8.18217H187.562V6.30566H197.698Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.061 14.1318L208.248 15.694H206.188L211.071 6.30566H212.974L217.857 15.694H215.797L214.984 14.1318H209.061ZM212.022 8.44408L210.037 12.2495H214.007L212.022 8.44408Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.518 6.30566H231.332V13.8175H239.196V15.694H229.518V6.30566Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3923 0H92.959V22H93.3923V0Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4551_10176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 22,
    fill: "white",
    transform: "translate(0.195312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.f02a2b32b177f68637853cc4848e36b5.svg";
export { ForwardRef as ReactComponent };